import React, { memo, useEffect } from "react";

const PayformComponent = ({ transactionAmountBreakdown, payformLink, onSuccess }) => {
    function onSuccessInternal(parsedData) {
        if (onSuccess) {
            onSuccess(parsedData, transactionAmountBreakdown);
        }
    }

    function onMessage(event) {
        if (event.origin.includes("payaconnect.com")) {
            const parsedData = JSON.parse(event.data);
            if (parsedData.status_id === 101) {
                onSuccessInternal(parsedData);
            } else {
                throw new Error("Not sure how to handle this");
            }
        }
    }

    useEffect(() => {
        window.addEventListener("message", onMessage, false);

        return () => {
            window.removeEventListener("message", onMessage, false);
        };
    }, [payformLink]);
    return (
        <iframe
            src={payformLink}
            width="750px"
            height="650px"
            className="payformLink"
            frameBorder={0}
            scrolling={"no"}
        />
    );
};

export const Payform = memo(PayformComponent);
